/* eslint-disable global-require */
import globModules from './glob-modules';

const reactModule = (Component, nodeList) => {
  const React = require('react');
  const { createRoot } = require('react-dom/client');

  nodeList.forEach(node =>
    createRoot(node).render(<Component {...node.dataset} />)
  );
};

const modules = [
  {
    name: 'header',
    loader: () => import('./modules/header')
  },
  {
    name: 'informationAlert',
    loader: () => import('./modules/informationAlert')
  },
  {
    name: 'videoModal',
    loader: () => import('./modules/videoModal')
  },
  {
    name: 'leadershipModal',
    loader: () => import('./modules/leadershipModal')
  },
  {
    name: 'linkModal',
    loader: () => import('./modules/linkModal')
  },
  {
    name: 'referencesModal',
    loader: () => import('./modules/referencesModal')
  },
  {
    name: 'twitterHighlights',
    loader: () => import('./modules/twitterHighlights')
  },
  {
    name: 'recentNews',
    loader: () => import('./modules/recentNews')
  },
  {
    name: 'dropdown',
    loader: () => import('./components/dropdown')
  },
  {
    name: 'inputField',
    loader: () => import('./components/inputField')
  },
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'pageTabs',
    loader: () => import('./modules/pageTabs')
  },
  {
    name: 'sitecoreForm',
    loader: () => import('./modules/sitecoreForm')
  },
  {
    name: 'columnGrid',
    loader: () => import('./modules/columnGrid')
  },
  {
    name: 'mastheadFrame',
    loader: () => import('./modules/mastheadFrame')
  },
  {
    name: 'twoFourCardArray',
    loader: () => import('./modules/twoFourCardArray')
  },
  {
    name: 'cookieWarning',
    loader: () => import('./modules/cookieWarning')
  },
  {
    name: 'locationsMap',
    loader: () => import('./modules/locationsMap/locationsMap')
  },
  {
    name: 'searchResults',
    loader: () => import('./modules/searchResults'),
    render: reactModule
  },
  {
    name: 'searchResources',
    loader: () => import('./modules/searchResources'),
    render: reactModule
  },
  {
    name: 'newsFeed',
    loader: () => import('./modules/newsFeed'),
    render: reactModule
  },
  {
    name: 'mediaGallery',
    loader: () => import('./modules/media-gallery')
  },
  {
    name: 'contentCardSlider',
    loader: () => import('./modules/content-card-slider')
  },
  {
    name: 'cardContent',
    loader: () => import('./components/content-card')
  },
  {
    name: 'registerForm',
    loader: () => import('./modules/bu/register')
  },
  {
    name: 'threeColumnModal',
    loader: () => import('./modules/bu/threeColumnModal')
  },
  {
    name: 'threeColumnIcon',
    loader: () => import('./modules/bu/threeColumnModal')
  },
  {
    name: 'productImageContent',
    loader: () => import('./modules/bu/productImageContent')
  },
  {
    name: 'imageContentTab',
    loader: () => import('./modules/bu/imageContentTab')
  },
  {
    name: 'mastheadSlider',
    loader: () => import('./modules/content-card-slider')
  },
  {
    name: 'forgotCred',
    loader: () => import('./modules/bu/forgotCredentials')
  },
  {
    name: 'userInfo',
    loader: () => import('./modules/bu/userInfo')
  },
  {
    name: 'languageSelector',
    loader: () => import('./modules/languageSelector')
  },
  {
    name: 'contactUsTabs',
    loader: () => import('./modules/contactUsTabs')
  },
  {
    name: 'backToTopButton',
    loader: () => import('./components/backToTopButton')
  },
  {
    name: 'maskHandler',
    loader: () => import('./modules/maskHandler')
  },
  {
    name: 'confirmationModal',
    loader: () => import('./modules/confirmarionModal')
  },
  {
    name: 'SearchResult',
    loader: () => import('./modules/newSearch'),
    render: reactModule
  },
  {
    name: 'PredectiveSearch',
    loader: () => import('./modules/predectiveSearch'),
    render: reactModule
  },
  {
    name: 'quebecModal',
    loader: () => import('./modules/quebecModal')
  }
];

export default [...globModules, ...modules];
